import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Link, Paper, Snackbar, Typography, useTheme } from '@mui/material'
import { memo, useCallback, useEffect, useState } from 'react'
import InfoIcon from '../../assets/icons/InfoIcon'
import { clientVersionManager } from '../../util/clientVersion'

const TITLE = 'New version available'

const ClientVersionUpdatePrompt = () => {
    const theme = useTheme()
    const [open, setOpen] = useState(false)

    useEffect(() => clientVersionManager.subscribe(() => setOpen(true)), [])

    const handleReload = useCallback(() => {
        clientVersionManager.refreshApp()
    }, [])

    const handleDismiss = useCallback(() => {
        clientVersionManager.markNotificationDismissed()
        setOpen(false)
    }, [])

    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            sx={{
                bottom: { xs: 16, sm: 24 },
                left: { xs: 16, sm: 24 },
                zIndex: theme.zIndex.snackbar,
            }}
        >
            <Paper
                elevation={8}
                sx={{
                    position: 'relative',
                    width: 320,
                    maxWidth: 'calc(100vw - 32px)',
                    p: 2,
                    pr: 5,
                    borderRadius: 1,
                    bgcolor: 'background.paper',
                    border: 1,
                    borderColor: 'divider',
                }}
            >
                <IconButton
                    aria-label="Dismiss"
                    size="small"
                    onClick={handleDismiss}
                    sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>

                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <InfoIcon sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }} />

                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" color="text.primary">
                            {TITLE}
                        </Typography>
                        <Link
                            component="button"
                            type="button"
                            color="blue"
                            underline="hover"
                            onClick={handleReload}
                            sx={{
                                p: 0,
                                mt: 0.25,
                                minWidth: 0,
                                border: 0,
                                background: 'none',
                                cursor: 'pointer',
                                fontWeight: 400,
                                fontSize: '0.875rem',
                                lineHeight: 1.43,
                                textAlign: 'left',
                            }}
                        >
                            Reload
                        </Link>
                    </Box>
                </Box>
            </Paper>
        </Snackbar>
    )
}

export default memo(ClientVersionUpdatePrompt)
